<template>
  <div class="d-flex align-items-center">
    <div
      class="switch"
      @click="handleSwitchClick"
      :class="{ active: isActive === true }"
    >
      <div class="indicator"></div>
    </div>
    <span @click="handleSwitchClick" v-if="withStatus">{{
      isActive ? "Enabled" : "Disabled"
    }}</span>
  </div>
</template>

<script>
export default {
  name: "Toggler",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    withStatus: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.isActive = this.value;
  },
  data: () => ({
    isActive: false
  }),
  watch: {
    value(val) {
      this.isActive = val;
    }
  },
  methods: {
    handleSwitchClick() {
      this.isActive = !this.isActive;
      this.$emit("toggle");
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  cursor: pointer;
  font-family: "Gotham";
  font-size: $font-size-xs;
  margin-left: 14px;
}
</style>
